import React from "react";
import "./PriceCalculation.css";

const PriceCalculation = () => {
  return (
    <section className="price-calc">
      <h3 className="price-calc-title">How we calculate price:</h3>

      <div className="price-calc-row">
        {/* PLAN */}
        <div className="price-card">
          <div className="img-box">
            <img src="assets/images/plan.png" alt="Plan" />
          </div>
          <h2>Plan</h2>
          <p>
            Your plan includes a number of users with pricing calculated per
            user / month based on your team size.
          </p>
        </div>

        {/* PLUS */}
        <div className="operator">+</div>

        {/* MODULES */}
        <div className="price-card">
          <div className="img-box">
            <img src="assets/images/modules.png" alt="Modules" />
          </div>
          <h2>Modules</h2>
          <p>
            You select only the modules you need, each tailored to your specific
            requirements and charged as a flat debates monthly fee, regardless
            of user count.
          </p>
        </div>

        {/* EQUAL */}
        <div className="operator">=</div>

        {/* PRICE */}
        <div className="price-card">
          <div className="img-box">
            <img src="assets/images/price.png" alt="Your price" />
          </div>
          <h2>Your price</h2>
          <p>
            With everything you need and nothing you don’t.
          </p>
        </div>
      </div>

      <div className="price-cta">
        <button>Book 1:1 Call on pricing</button>
      </div>
    </section>
  );
};

export default PriceCalculation;
